import { render, staticRenderFns } from "./EventSummary.vue?vue&type=template&id=60f46974&"
import script from "./EventSummary.vue?vue&type=script&lang=js&"
export * from "./EventSummary.vue?vue&type=script&lang=js&"
import style0 from "./EventSummary.vue?vue&type=style&index=0&id=60f46974&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports